module.exports = __webpack_public_path__ + "img/alloy@2x.6b22a20.jpg";